import { Injectable } from '@angular/core';

@Injectable()
export class ScreenSizeService {
  public windowRef: any;

  public breakpoints = {
    $breakSmall: 475,
    $breakTablet: 768,
    $breakWide: 1024,
    $breakWidest: 1600
  };

  constructor() {
    this.windowRef = window;
  }

  get isMobile(): boolean {
    return this.windowRef.innerWidth <= this.breakpoints.$breakSmall;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/screen-size.service.ts